
export const RESOLUTIONS = [
    2048.256,
    1024.128,
    512.064,
    256.032,
    128.016,
    64.008,
    32.004,
    16.002,
    8.001,
    4.0005,
    2.00025,
    1.000125,
    0.5000625,
    0.25003125,
    0.125015625,
    0.0625078125
];

const CUZK_WMTS_TILE_GRID = {
    extent: [
        -925000.000000000000, -1444353.535999999800,
        -400646.464000000040, -920000.000000000000
    ],
    projection: 'epsg:5514',
    resolutions: RESOLUTIONS,
    matrixIds: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15']
};

const MAP_PROJECT = {
    projection: 'EPSG:5514',
    resolutions: RESOLUTIONS,
    extent: [
        -925000.000000000000, -1444353.535999999800,
        -400646.464000000040, -920000.000000000000
    ],
    minZoom: 0,
    maxZoom: 15,

    layers: [{
        id: 'zm',
        type: 'WMTS',
        source: {
            params: {
                url: 'https://ags.cuzk.gov.cz/arcgis1/rest/services/ZTM/MapServer/WMTS',
                layer: 'ZTM',
                matrixSet: 'default028mm',
                projection: 'epsg:5514',
                format: 'image/png',
                style: 'default'
            },
            tileGrid: CUZK_WMTS_TILE_GRID
        }
    }, {
        id: 'orto',
        type: 'WMTS',
        source: {
            params: {
                url: 'https://ags.cuzk.gov.cz/arcgis1/rest/services/ORTOFOTO/MapServer/WMTS',
                layer: 'ORTOFOTO',
                matrixSet: 'default028mm',
                projection: 'EPSG:5514',
                format: 'image/jpeg',
                style: 'default'
            },
            tileGrid: CUZK_WMTS_TILE_GRID
        }
    }, {
        id: 'cuzk_km',
        type: 'ImageWMS',
        maxResolution: 2.00025,
        source: {
            url: 'https://services.cuzk.cz/wms/local-KM-wms.asp',
            params: {'LAYERS': 'KN'}
        }
    }, {
        id: 'uhul_honitby_hranice',
        type: 'ImageWMS',
        source: {
            url: 'https://gp2.uhul.cz/wms_mysl/service.svc/get',
            params: {'LAYERS': 'Honitby_hranice'}
        }
    }, {
        id: 'wh_honitby_hranice',
        type: 'ImageWMS',
        source: {
            url: 'https://portal.nasemapy.cz/wms/mysliveckyportal/honitby',
            params: {'LAYERS': 'dft_all'}
        }
    }],

    virtualLayers: [{
        id: 'base_zm',
        base: true,
        layers: ['zm'],
        title: 'Základní mapa [ČÚZK]'
    }, {
        id: 'base_orto',
        base: true,
        layers: ['orto'],
        title: 'Letecká mapa [ČÚZK]'
    }, {
        id: 'over_cuzk_km',
        layers: ['cuzk_km'],
        title: 'Katastrální mapa [ČÚZK]'
    }, {
        id: 'over_uhul_honitby_hranice',
        layers: ['uhul_honitby_hranice'],
        title: 'Hranice honiteb [ÚHÚL]'
    }, {
        id: 'over_wh_honitby_hranice',
        layers: ['wh_honitby_hranice'],
        title: 'Hranice honiteb [webHONITBA]'
    }],

    virtualLayerGroups: [{
        id: 'base',
        base: true,
        title: 'Podkladové vrstvy',
        layers: [
            'base_zm',
            'base_orto'
        ]
    }, {
        id: 'over',
        title: 'Volitelné vrstvy',
        layers: [
            'over_cuzk_km',
            'over_uhul_honitby_hranice',
            'over_wh_honitby_hranice'
        ]
    }],

    defaultVisibleLayers: ['base_zm', 'over_wh_honitby_hranice']
};

export default MAP_PROJECT;
